/* Text of the index page (/articles). It comes from the writing chat.
   Empty fields are not shown on the page. */
export const articlesPage = {
  /** Page title, also the label of the link in the header. */
  title: "Articles",
  /** One or two sentences under the title. */
  intro: "A small place where I write down what I am learning about design thinking, product design, accessibility and design systems.",
  /** Meta description of the index page. Empty means the description of the site. */
  description: "Articles by Lorenzo Bernardi on design thinking, product design, accessibility and design systems.",
  /** IMAGE SLOT for the header visual: a wide picture across the top of the
      page, there for the brand. 2560 by 720. Phones show the middle of it, so
      keep what matters in the centre. Upload it in Readdy and paste its URL in
      `src`. Leave `alt` empty when the picture is only decoration. */
  headerImage: { src: "", alt: "" },
};
